<template>
  <div class="h-100">
    <div class="loader-cont" v-dxloader="isLoader"></div>
    <div class="row h-100" v-show="!isLoader">
      <div class="content-wrapper-before gradient-45deg-indigo-purple"></div>
      <div class="breadcrumbs-dark pb-0 pt-4" id="breadcrumbs-wrapper">
        <!-- Search for small screen-->
        <div class="container">
          <div class="row">
            <div class="col s10 m6 l6 alignLeft">
              <h5 class="card-title alignLeft white-text">Packages</h5>
            </div>
            <div class="col s10 m6 l6 alignRight">
              <a data-target="modal-service" @click="preAdd()" class="btn modal-trigger add_btn">
                <span>Add Package</span>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="col s12 p-0" style="height:calc(100% - 45px)">
        <div class="container p-0 h-100">
          <div class="section p-0 h-100">
            <div class="row m-0 h-100">
              <div class="col s12 m12 l12 p-0 h-100">
                <div id="responsive-table" class="card card card-default scrollspy p-0 h-100">
                  <div class="card-content h-100">
                    <div class="row h-100">
                      <div class="col s12 packages h-100">
                        <table class="responsive-table">
                          <thead>
                            <tr>
                              <th data-field="index">S.No</th>
                              <th data-field="id">Name</th>
                              <th data-field="id">Description</th>
                              <th data-field="name">Info</th>
                              <th data-field="total">Formula</th>
                              <th data-field="date">Created At</th>
                              <!-- <th data-field="status">Status</th> -->
                              <th data-field="status">Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(packitem,index) in packagesList" :key="packitem.id">
                              <td>{{index+1}}.</td>
                              <td>{{packitem.name}}</td>
                              <td>{{packitem.description}}</td>
                              <td>Serviced {{packitem.duration}} times in a {{packitem.metric}}</td>
                              <td>{{packitem.formula}}</td>
                              <td>{{packitem.created_at | date('D MMM YY, hh:mm a')}}</td>
                              <!-- <td>
                                                                <div class="switch">
                                                                    <label>
                                                                        <input :id="'toggle' + index" :name="'toggle' + index"  v-model="packitem.is_active" @change="onStatusChange($event,packitem)" type="checkbox">
                                                                        <span class="lever"></span>
                                                                    </label>
                                                                </div>
                              </td>-->
                              <td>
                                <a
                                  @click="selectPackage(packitem)"
                                  data-target="modal-service"
                                  class="modal-trigger btn-floating mb-1 waves-effect waves-light"
                                >
                                  <i class="material-icons">edit</i>
                                </a>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="modal-service" class="modal mo-40">
      <div class="modal-header header_br">
        <h6 class="alignLeft">{{isEdit ? 'Update' : 'Add'}} Package</h6>
      </div>
      <form class="login-form">
        <div class="modal-content">
          <div class="row">
            <div class="col s12 m12 l12">
              <div class="row margin-model">
                <div class="input-field col s7">
                  <input
                    maxlength="50"
                    v-model="currPackage.name"
                    id="name"
                    name="name"
                    type="text"
                  />
                  <label for="name" class="center-align">Package Name</label>
                  <div class="error-message" v-if="nameErr">{{nameErr}}</div>
                </div>
                <div class="input-field col s5">
                  <input
                    :disabled="isEdit"
                    maxlength="20"
                    v-model="currPackage.formula"
                    id="formula"
                    name="formula"
                    type="text"
                  />
                  <label for="name" class="center-align">Formula</label>
                </div>
                <div
                  class="input-field col s12 pack-ta"
                  :class="{'error-ta' : !currPackage.description}"
                >
                  <!-- <input v-model="currPackage.description" id="description" name="description" type="text"> -->
                  <textarea
                    id="description"
                    maxlength="250"
                    v-model="currPackage.description"
                    data-length="250"
                    name="description"
                    class="materialize-textarea"
                  ></textarea>
                  <label for="name" class="center-align">Description</label>
                </div>
                <div class="input-field col s12">
                  <div class="dur_metric">
                    <div class="inner-block pack duration">
                      <span>Serviced</span>
                      <!-- <input v-model="currPackage.duration" id="duration" name="duration" type="text"> -->
                      <select id="duration" name="duration" v-model="currPackage.duration">
                        <option
                          :value="item"
                          v-for="item in [1,2,3,4,5,6,7,8,9,10,11,12]"
                          :key="item"
                        >{{item}}</option>
                      </select>
                    </div>
                    <span class="d-inline-block pr-3">times in a</span>
                    <div class="inner-block pack">
                      <!-- <span>times in a</span> -->
                      <select id="metric" name="metric" v-model="currPackage.metric">
                        <option value="month">Month</option>
                        <option value="year">Year</option>
                      </select>
                      <!-- <input v-model="currPackage.metric" id="metric" name="metric" type="text"> -->
                    </div>
                  </div>
                  <label for="name" class="center-align active">Info</label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <a class="modal-action modal-close waves-effect btn-flat">Cancel</a>
          <button
            type="submit"
            v-loader-button="isLoading"
            name="action"
            class="pointer waves-effect btn"
          >Save</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import jquery from "jquery";
import validate from "jquery-validation";
export default {
  data() {
    return {
      packagesList: [],
      nameErr: "",
      isLoader: true,
      isLoading: false,
      currPackage: {
        name: "",
        metric: "month",
        duration: "1",
        description: "",
        formula: ""
      },
      isEdit: false,
      errorMessage: ""
    };
  },
  created() {
    setTimeout(() => {
      $(".modal").modal({ dismissible: false });
      $(".margin-model input").on("keyup", e => {
        if (
          $(e.target)
            .next()
            .attr("class") == "error"
        ) {
          $(e.target)
            .next()
            .remove();
        }
        this.errorMessage = "";
        this.nameErr = "";
      });
    }, 500);

    setTimeout(() => {
      this.Validator = $(".login-form").validate({
        rules: {
          name: {
            required: true
          },
          description: {
            required: true
          },
          formula: {
            required: true
          }
        },
        errorElement: "div",
        errorPlacement: function(error, element) {
          var placement = $(element).data("error");
          if (placement) {
            $(placement).append(error);
          } else {
            error.insertAfter(element);
          }
        },
        submitHandler: e => {
          $("button").attr("disabled", "disabled");
          setTimeout(() => {
            $("button").removeAttr("disabled");
          }, 500);
          setTimeout(() => {
            if (this.errorMessage == "" && !this.nameErr) {
              if (this.isEdit) {
                this.updatePackage();
              } else {
                this.addPackage();
              }
            }
          }, 200);
          return false;
        }
      });
    }, 500);
    setTimeout(() => {
      $("select").formSelect();
      $("textarea").characterCounter();
    }, 200);
    this.isLoader = true;
    this.listPackages();
  },
  methods: {
    listPackages() {
      ajax.get(
        Constants.default.APIURL.ServicePackages,
        res => {
          this.packagesList = res.data;
          this.isLoader = false;
          if (this.packagesList.length == 0) {
            Vue.showNoDataBlock(".packages");
          } else {
            Vue.hideNoDataBlock(".packages");
          }
        },
        err => {
          this.isLoader = false;
        }
      );
    },
    deActivatePackage(id) {
      return new Promise(resolve => {
        ajax.delete(
          Constants.default.APIURL.ServicePackages + id + "/",
          {},
          res => {
            resolve(true);
          },
          err => {
            resolve(false);
          }
        );
      });
    },
    onStatusChange(e, packageItem) {
      let toggle = packageItem.is_active;
      setTimeout(() => {
        e.target.checked = !e.target.checked;
      }, 0);
      swal({
        title: "Are you sure?",
        text: `Do you want to ${!toggle ? "disable" : "enable"} this Package`,
        icon: "warning",
        dangerMode: !toggle,
        buttons: {
          cancel: true,
          delete: `Yes, ${!toggle ? "disable" : "enable"} it`
        }
      }).then(async willDelete => {
        if (willDelete) {
          let result = await this.deActivatePackage(packageItem.id);
          if (result) {
            e.target.checked = !e.target.checked;
            packageItem.is_active = e.target.checked;
          }
        }
      });
    },
    selectPackage(packageItem) {
      this.currPackage = {
        id: packageItem.id,
        name: packageItem.name,
        description: packageItem.description,
        duration: JSON.stringify(packageItem.duration),
        metric: packageItem.metric,
        formula: packageItem.formula
      };
      this.isEdit = true;
      this.nameErr = "";
      this.errorMessage = "";
      setTimeout(() => {
        $("#metric").formSelect();
        $("#duration").formSelect();
        this.Validator.resetForm();
        M.updateTextFields();
      }, 100);
    },
    preAdd() {
      this.isEdit = false;
      this.nameErr = "";
      this.errorMessage = "";
      this.currPackage = {
        metric: "month",
        duration: "1"
      };
      $('#metric').val('month').formSelect()
        $('#duration').val('1').formSelect()
      setTimeout(() => {
        this.Validator.resetForm();
        M.updateTextFields();
      }, 100);
    },
    updatePackage() {
      this.isLoading = true;
      let query = JSON.parse(JSON.stringify(this.currPackage));
      delete query.formula;
      ajax.patch(
        Constants.default.APIURL.ServicePackages + this.currPackage.id + "/",
        query,
        res => {
          Vue.toast("Package was updated successfully");
          $(".modal").modal("close");
          this.isLoading = false;
          this.listPackages();
        },
        err => {
          this.isLoading = false;
          // Vue.toast("",err);
          this.handleError(err);
        }
      );
    },
    addPackage() {
      if (!this.currPackage.metric) {
        $("#metric").focus();
        return;
      }
      if (!this.currPackage.duration) {
        $("#duration").focus();
        return;
      }
      this.isLoading = true;
      ajax.post(
        Constants.default.APIURL.ServicePackages,
        this.currPackage,
        res => {
          Vue.toast("Package was added successfully");
          $(".modal").modal("close");
          this.isLoading = false;
          this.listPackages();
        },
        err => {
          this.isLoading = false;
          this.handleError(err);
        }
      );
    },
    handleError(err) {
      let errorMessage = "";
      if (err.status == 400) {
        if (err.data) {
          if (err.data.non_field_errors) {
            errorMessage = err.data.non_field_errors[0];
            Vue.toast(errorMessage);
          } else {
            if (Object.keys(err.data).length > 0) {
              this.nameErr = err.data["name"]
                ? "Package name already exists"
                : "";
            }
          }
        } else {
          if (err.non_field_errors) {
            errorMessage = err.non_field_errors[0];
            Vue.toast(errorMessage);
          } else {
            if (Object.keys(err).length > 0) {
              if (Object.keys(err.data).length > 0) {
                this.nameErr = err.data["name"]
                  ? "Package name already exists"
                  : "";
              }
            }
          }
        }
        errorMessage = errorMessage ? errorMessage : "Something went wrong.";
      } else if (err.status == 401) {
      } else {
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.add_btn {
  margin-top: 10px;
  margin-right: 10px;
}

.error-message {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  text-align: right;
}

.margin-model {
  margin: 0px !important;
}

.dur_metric {
  text-align: left;
  display: flex;
  padding-top: 10px;
  justify-content: flex-start;
  align-content: center;
  input {
    width: auto !important;
    line-height: 0;
    height: 1.4rem;
    max-width: 50px;
    padding: 0 0 0 10px;
    box-shadow: none !important;
    margin: 0;
  }
  .inner-block {
    width: auto;
    margin-right: 20px;
    display: flex;
    align-items: center;
    span {
      display: inline-block;
      padding-right: 10px;
    }
  }
}

.btn-floating {
  color: #212121;
  background: white !important;
}

.btn-floating i {
  color: #212121;
}
a.add_btn {
  margin-top: 10px;
  margin-right: 10px;
  span {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.input-field {
  .fs-8 {
    font-size: 0.8rem;
  }
  input {
    font-size: 14px;
  }
}
</style>

